import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
const LatestUpdate = () => {
    const navigate = useNavigate();

    const [lastUpdate, setLastUpdate] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.lastUpdate,
            })
            .then((response) => {
                const lastDoc = response.data.allLatest_updates .edges[0].node;
                setLastUpdate(lastDoc);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <div>
            <div className="application-process pb-2">
                <div className="container contapp">
                    <div className="row">
                      
                        {/* <div className="col-sm mb-4 mb-md-0">
                            <div
                                onClick={() => navigate("/qualifiedtm")}
                                className="qualified-team"
                            >
                                <h6 className=" p-0 m-0">{lastUpdate?.btn_text_1}  </h6>
                            </div>
                        </div> */}
                        <div className="col-sm mb-4 mb-md-0">
                            <div
                                onClick={() => navigate("/qualifiedtm3")}
                                className="qualified-team"
                            >
                                <h6 className=" p-0 m-0">{lastUpdate?.btn_text_2}</h6>
                            </div>
                        </div>
                        <div className="col-sm"></div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default LatestUpdate;